/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'content',
        'linksContent',
        'copyrightContent',
        'subscribeContent',
        'subscribeContentDesktop',
        'downloadContent',
        'localeSelector',
        'localeDropdown',
        'localeDropdownOption',
        'copyright',
        'socialIcons',
        'vat'
    ],
    baseStyle:  (props) => ({
        container: {
            width: 'full',
            background: 'webTheme.backgroundDefault',
             ...(props.isPDP && {
                marginBottom: {base: '120px', lg: '94px'}
            })
        },
        content: {
            maxWidth: 'container.xxxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: 'webTypo.textPrimary',
            borderTop: '1px solid',
            borderTopColor: 'webTheme.strokeTertiary'
        },
        linksContent: {
            borderTop: {base: 0, lg: 0},
            borderTopColor: 'webTheme.strokeTertiary',
            paddingTop: {base: 4, lg: 6},
            paddingBottom: {base: 4, lg: 12},
            paddingLeft: {base: 4, lg: 6},
            paddingRight: {base: 4, lg: 2}
        },
        copyrightContent: {
            borderTop: {base: 0, lg: '1px solid'},
            borderColor: {lg: 'webTheme.strokeTertiary'},
            paddingTop: {base: 3, lg: 3},
            paddingBottom: {base: 3, lg: 3},
            paddingLeft: {base: 4, lg: 6},
            paddingRight: {base: props?.isChatActive ? 20 : 4, lg: props?.isChatActive ? 22 : 6},
            gridColumn: {
                base: 'span 1',
                lg: props?.showCountrySelector ? 'span 2' : 'span 3'
            },
            order: {base: 1, lg: 0}
        },
        copyright: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular'
        },
        subscribeContent: {
            margin: {base: '0 auto'},
            paddingTop: {base: 8, lg: 6},
            paddingBottom: {base: 8, lg: 6},
            paddingLeft: {base: 4, lg: 6},
            paddingRight: {base: 4, lg: 6},
            borderLeft: {lg: '1px solid'},
            borderLeftColor: {lg: 'webTheme.strokeTertiary'}
        },
        subscribeContentDesktop: {
            display: {base: 'none', lg: 'flex'},
            flexFlow: {base: 'none', lg: 'column'},
            justifyContent: {base: 'none', lg: 'center'},
            width: {base: 'none', lg: '100%'}
        },
        downloadContent: {
            paddingTop: {base: 3, lg: 0},
            paddingBottom: {base: 8, lg: 0},
            paddingLeft: {base: 4, lg: 0},
            paddingRight: {base: 4, lg: 0},
            width: {base: 'none', lg: '100%'}
        },
        localeSelector: {
            display: 'inline-block',
            marginTop: 8
        },
        localeDropdown: {
            background: 'gray.800',
            _hover: {
                background: 'whiteAlpha.500'
            }
        },
        localeDropdownOption: {
            color: 'black'
        },
        socialIcons: {
            marginTop: 4
        },
        vat: {
            display: {base: 'block', lg: 'inline-block'},
            paddingLeft: {lg: 1}
        }
    })
}
